import React from 'react';
import "../../index.css";

const PromoBar = () => {
    return (
        <div className="banner-container">
        <div className="banner-content">
          <div className="banner-icon">
            <i className="fas fa-laptop-code" style={{ fontSize: '40px', color: 'white' }}></i>
          </div>
          <p className="banner-text">
            ¡INVIERTE EN TU FUTURO! APROVECHA LAS PROMOCIONES ANTES QUE DESAPAREZCAN
          </p>
        </div>
      </div>
    );
};

export default PromoBar;
